
import HeaderTitleContent from '../../../common/components/atom/HeaderTitleContent/HeaderTitleContent'
import Table from '../../../common/components/molecule/Table/Table'

export default function ListInfraPage() {
  return (
    <div>
    <HeaderTitleContent>Suivis Infra</HeaderTitleContent>
    <Table emptyMessage='Aucun suivis Infra' headerTitle={['Nom', 'Description']} />
    </div>
  )
}
